/**
 * Does a caller's `className` already set this property? The shared primitives add phone
 * defaults (`max-md:` classes, decision P10 in `docs/platform/PHASES.md`) only where the caller
 * has not: a media-query class beats a caller's plain one, and twMerge cannot see the two as a
 * conflict, so without this check a phone default would silently override a deliberate `h-12`,
 * `p-0` or `max-h-[85vh]`.
 *
 * A utility counts with any variant prefix (`md:h-9`) and with `!important` (`!p-0`).
 */
const UTILITY = {
  /** `h-*`, `size-*` */
  height: 'h|size',
  /** `h-*`, `max-h-*` */
  maxHeight: 'max-h|h',
  /** `p-*` and any one-sided padding */
  padding: 'p[xytblrse]?',
  /** Padding that reaches the sides: `p-*`, `px-*`, `pl-*`, `pr-*`, `ps-*`, `pe-*` */
  paddingX: 'p[xlrse]?',
} as const;

const PATTERNS = Object.fromEntries(
  Object.entries(UTILITY).map(([key, names]) => [key, new RegExp(`(?:^|\\s)(?:[\\w-]+:)*!?(?:${names})-`)]),
) as Record<keyof typeof UTILITY, RegExp>;

export function callerSets(className: string | null | undefined, property: keyof typeof UTILITY): boolean {
  return Boolean(className) && PATTERNS[property].test(className as string);
}
